import React, { useState } from 'react';
import { MenuIcon, XIcon, ArrowUpRightIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm" data-id="element-167">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center" data-id="element-168">
        <div className="flex items-center" data-id="element-169">
          <a href="#" className="flex items-center" data-id="element-170">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hkWGY44RQgzNCHJG7k4dv9/Logo_Icon.png" alt="Sales Source Logo" className="h-10" data-id="element-171" />
            <div className="ml-3" data-id="element-172">
              <span className="text-xl font-bold text-black" data-id="element-173">Sales Source</span>
            </div>
          </a>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-174">
          <a href="#services" className="text-black hover:text-[#FF7A39] font-medium transition-colors" data-id="element-175">
            Services
          </a>
          <a href="#process" className="text-black hover:text-[#FF7A39] font-medium transition-colors" data-id="element-176">
            How It Works
          </a>
          <a href="#results" className="text-black hover:text-[#FF7A39] font-medium transition-colors" data-id="element-177">
            Success Stories
          </a>
          <a href="#resources" className="text-black hover:text-[#FF7A39] font-medium transition-colors" data-id="element-178">
            Resources
          </a>
          <a href="#about" className="text-black hover:text-[#FF7A39] font-medium transition-colors" data-id="element-179">
            About
          </a>
          <a href="https://calendar.app.google/UHmu8gqmNjGApsL99" className="bg-[#FF7A39] text-black px-4 py-2 rounded-md font-medium hover:bg-[#FF7A39]/90 transition-all flex items-center gap-2 shadow-sm" data-id="element-180">
            Talk to us <ArrowUpRightIcon size={16} data-id="element-181" />
          </a>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-black" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-182">
          {isMenuOpen ? <XIcon size={24} data-id="element-183" /> : <MenuIcon size={24} data-id="element-184" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white w-full py-5 px-6 shadow-md border-t border-gray-100 absolute" data-id="element-185">
          <nav className="flex flex-col space-y-4" data-id="element-186">
            <a href="#services" className="text-black hover:text-[#FF7A39] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-187">
              Services
            </a>
            <a href="#process" className="text-black hover:text-[#FF7A39] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-188">
              How It Works
            </a>
            <a href="#results" className="text-black hover:text-[#FF7A39] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-189">
              Success Stories
            </a>
            <a href="#resources" className="text-black hover:text-[#FF7A39] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-190">
              Resources
            </a>
            <a href="#about" className="text-black hover:text-[#FF7A39] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-191">
              About
            </a>
            <a href="https://calendar.app.google/UHmu8gqmNjGApsL99" className="bg-[#FF7A39] text-black px-4 py-3 rounded-md font-medium hover:bg-[#FF7A39]/90 transition-all inline-flex items-center gap-2 w-fit shadow-sm mt-2" onClick={() => setIsMenuOpen(false)} data-id="element-192">
              Talk to us <ArrowUpRightIcon size={16} data-id="element-193" />
            </a>
          </nav>
        </div>}
    </header>;
};